import React, { useState } from "react";
import { useHistory } from "react-router";
import EmptyListPlaceholder from "./EmptyListPlaceholder";
import { Tooltip } from "@mui/material";
import ALoader from "views/pages/manage/common/a-loader";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomPaginationWithoutCount from "components/CustomPaginationWithoutCount/CustomPaginationWithoutCount";
import moment from "moment";
import { CourseDetailsPopupById } from "views/pages/manage/unAssigned/studentCharges/common";
import { transformChargeStatus } from "views/pages/manage/unAssigned/studentCharges/studentChargesDetails/common";
import { chargesStatus } from "views/pages/manage/unAssigned/studentCharges/studentList";
import { chargeStatusMapping } from "views/pages/manage/unAssigned/studentCharges/common";
import { defaulStatustStyles } from "views/pages/manage/unAssigned/studentCharges/studentList";
import { programActionStyles } from "views/pages/manage/unAssigned/studentCharges/studentList";
import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";

const StudentList = ({
  userPermissions,
  rowsData,
  rowCount,
  nextButtonHandler,
  currentPage,
  isLastPage,
  businessAreaMap,
  showPagination = true,
  isCentralizedAdmCase = false,
}) => {
  const history = useHistory();

  const StudentListColumns = [
    new AGridColDef("psid", "PSID", false)
      .setMinWidth(120)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <span
          onClick={() =>
            window.open(
              history.createHref({
                pathname: `/admin/edp/studentDetails/${params.value}`,
              }),
              "_blank"
            )
          }
          style={{ color: "#00B0F5", fontSize: "14px", cursor: "pointer" }}
        >
          <Tooltip title={params?.value}>
            <span>{params?.value}</span>
          </Tooltip>
        </span>
      )),
    new AGridColDef("applicationId", "App. ID", false)
      .setMinWidth(90)
      .setFlex(0.25)
      .renderCellComponent((params) => (
        <Tooltip className="" title={params?.value}>
          <span>{params?.value}</span>
        </Tooltip>
      )),
    ,
    new AGridColDef("studentName", "Student Name", false)
      .setMinWidth(150)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <Tooltip className="ellipsis-text-container " title={params?.value}>
          <span>{params?.value}</span>
        </Tooltip>
      )),
    ,
    new AGridColDef("businessAreaDispVal", "BU", false)
      .setMinWidth(50)
      .setFlex(0.25)
      .renderCellComponent((params) => <span>{params.value}</span>),

    new AGridColDef("cashierOffice", "Cashier office")
      .setFlex(0.7)
      .renderCellComponent((params) => <span>{params.value}</span>),

    new AGridColDef("academicCareerValue", "Career")
      .setFlex(0.7)
      .renderCellComponent((params) => <span>{params.value}</span>),
    new AGridColDef("courseId", "Course ID", false)
      .setMinWidth(90)
      .setFlex(0.25)
      .renderCellComponent((params) => (
        <>
          <span style={{ marginRight: "2px" }}>{params?.value}</span>{" "}
          <CourseDetailsPopupById
            courseId={params?.value}
            placement="bottom"
            maxWidth="250px"
          />
        </>
      )),
    new AGridColDef("termDispVal", "Term", false)
      .setMinWidth(60)
      .setFlex(0.25)
      .renderCellComponent((params) => <span>{params?.value}</span>),
    new AGridColDef("registrationDate", "Registration Date", false)
      .setMinWidth(80)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <span>
          {params?.value ? moment(params?.value).format("DD-MM-YYYY") : "-"}
        </span>
      )),
    new AGridColDef("chargesStatus", "Latest Charge Status", false)
      .setMinWidth(120)
      .setFlex(0.5)
      .renderCellComponent((params) => {
        const chargeStatus = transformChargeStatus(params.value);
        return (
          <Tooltip title={chargeStatusMapping[chargeStatus] ?? "-"}>
            <span style={chargesStatus?.[chargeStatus] ?? {}}>
              {chargeStatus ?? "-"}
            </span>
          </Tooltip>
        );
      }),
    ,
    new AGridColDef("programAction", "Program Action", false)
      .setMinWidth(120)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <span
          style={programActionStyles?.[params.value] ?? defaulStatustStyles}
        >
          {params.value}
        </span>
      )),
    new AGridColDef("isPaymentCollectionEligible", "Action", false)
      .setMinWidth(100)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        isActiveBusinessArea({
          buLabel: params.row.businessAreaDispVal,
        }) || isCentralizedAdmCase ? (
          <AButton
            onClick={() =>
              window.open(
                history.createHref({
                  pathname: `admin/student/collectPayment/${
                    params?.row?.applicationId
                  }${isCentralizedAdmCase ? "?source=centralized-adm" : ""}`,
                })
              )
            }
            size="xs"
            variant="primary_filled"
            className="btn-left-0"
            disabled={!params?.value}
          >
            Select
          </AButton>
        ) : (
          <></>
        )
      ),
  ];

  return (
    <>
      <ADataGrid
        rows={rowsData}
        columns={StudentListColumns}
        rowId={(row) => JSON.stringify(row)}
        loading={rowsData.length === 0}
        emptyRowPlaceholder={() => <EmptyListPlaceholder />}
        sortColumnName="psid"
        components={{
          ...gridComponents,
        }}
        sx={{
          ...gridStyles,
        }}
        hidePagination={true}
      />
      {showPagination && (
        <CustomPaginationWithoutCount
          currentPage={currentPage}
          onPageChange={nextButtonHandler}
          isLastPage={isLastPage}
          noOfCurrentPageRecords={rowsData.length}
        />
      )}
    </>
  );
};

export default StudentList;
